<template>
<BaseModal :id="modal_name" :title="title" :size="'lg'">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <div class="table-responsive table-fix-head horizontal-scroll-reports" :style="`max-height: 35rem`">
            <table class="table">
                <thead>
                    <tr style="background-color: #fff">
                        <th style="font-weight: normal !important" class="header-item-manual" v-for="(item, i) in table_headers" :key="i" scope="col" v-html="item.text" />
                    </tr>
                </thead>
                <tbody>
                    <template>
                        <tr v-for="(history_item, i) in history" :key="i">
                            <td v-for="(item, j) in table_headers" v-html="history_item[item.value]" :key="j" />
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <CentralLiteButtons :done="true" />
    </template>
</BaseModal>
</template>

<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import CentralLiteButtons from '@/components/CentralLiteButtons.vue'
import eventBus from '@/plugins/eventBus'
import Resources from './resources';

export default {

    name: 'RoomProjectHistoryModal',

    props: [
        'title',
        'rest_api',
        'notyf',
        'breadcrumb',
        'history'
    ],

    components: {
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data() {
        return {
            modal_name: 'static-room-project-history',
            table_headers: Resources.table_headers_project_history_complete,
        }
    },

    watch: {

    },

    methods: {},

    mounted() {
        eventBus.$on('saveAndNew', () => {
            this.save_and_new = false
        })
    },

}
</script>
